const HeartCheckmark = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.9998 5.70806C12.9138 4.61025 14.273 3.9817 15.7014 3.99634C18.8727 3.99634 21.0036 6.97759 21.0036 9.75374C21.0036 15.5572 13.7786 20.003 11.9998 20.003C10.2211 20.003 2.99609 15.5572 2.99609 9.75374C2.99609 6.97759 5.12698 3.99634 8.2983 3.99634C9.72668 3.9817 11.0859 4.61025 11.9998 5.70806Z"
      stroke="#7D8690"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 7.7325V8.52148"
      stroke="#7D8690"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 10.0978C10.1168 9.12845 11.005 8.42768 12 8.51986"
      stroke="#7D8690"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 15.5449V14.7559"
      stroke="#7D8690"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14 13.1777C13.8832 14.1471 12.995 14.8479 12 14.7557"
      stroke="#7D8690"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.9491 9.75504C13.6482 8.96973 12.8569 8.46888 12 8.52134"
      stroke="#7D8690"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.0508 13.5234C10.3517 14.3088 11.143 14.8096 11.9999 14.7571"
      stroke="#7D8690"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 10.0996V10.0996C10 10.7677 10.4828 11.3428 11.1536 11.4739L12.8464 11.8045C13.5172 11.9355 14 12.5107 14 13.1788V13.1788"
      stroke="#7D8690"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default HeartCheckmark;
